<template>
  <div class="container">
    <div class="ui grid stackable">
      <div class="twelve wide column">
        <h1>Error Log</h1>
      </div>
    </div>

    <div class="ui divider"></div>

    <div id="table">
      <vuetable
        ref="vuetable"
        :api-url="apiUrl"
        :fields="fields"
        :data="errors"
        pagination-path
        :per-page="25"
        :multi-sort="true"
        :sort-order="sortOrder"
        @vuetable:pagination-data="onPaginationData"
        :http-options="httpOptions"
      >
        <template slot="actions" slot-scope="errors">
          <div class="table-button-container">
            <button class="ui button primary" @click="goToDetail(errors)">
              <i class="fa fa-edit"></i>
            </button>
          </div>
        </template>
      </vuetable>

      <vuetable-pagination
        ref="pagination"
        @vuetable-pagination:change-page="onChangePage"
      ></vuetable-pagination>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import APIService from "@/assets/js/APIService";
const apiService = new APIService();
import httpClient from '@/assets/js/HttpClient'

export default {
  name: "Errors",
  computed: {},
  components: {
    Vuetable,
    VuetablePagination,
  },
  data() {
    return {
      id: "",
      fields: [
        {
          name: "level",
          title: "Level",
          sortField: "level",
        },
        {
          name: "message",
          title: "Message (Truncated)",
        },
        {
          name: "date",
          title: "Date",
          sortField: "date",
        },
        // Buttons Column
        "__slot:actions",
      ],
      sortOrder: [
        {
          field: "date",
          sortField: "date",
          direction: "asc",
        },
      ],
      moreParams: {},
      errors: [],
      apiUrl: apiService.getErrorsUrl(),
      httpOptions: {
        headers: httpClient.defaults.headers
      },
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", () => this.onFilterReset());
    this.getErrors();
  },
  methods: {
    getErrors() {
      apiService.getErrors().then((data) => {
        this.errors = data;
      });
    },
    goToDetail(error) {
      this.$router.push({
        name: "ErrorsDetails",
        params: {
          id: error.rowData.id,
        },
      });
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(filterText) {
      this.moreParams.filter = filterText;
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterReset() {
      delete this.moreParams.filter;
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
  },
};
</script>

<style module></style>
